import { motion } from "framer-motion";
import { useContent } from "@/lib/content";

export default function Manifesto() {
  const c = useContent();
  const CHAPTERS = [c.manifesto_1, c.manifesto_2, c.manifesto_3, c.manifesto_4];
  return (
    <section
      id="la-palestra"
      data-testid="manifesto-section"
      className="relative px-6 md:px-16 py-28 md:py-40 max-w-[1400px] mx-auto"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-16 md:mb-24"
      >
        <h2 className="font-display text-5xl md:text-7xl tracking-wide text-bone leading-[0.95]">
          NON LA SOLITA
          <br />
          <span className="text-gold">PALESTRA.</span>
        </h2>
      </motion.div>

      <div className="flex flex-col gap-14 md:gap-20">
        {CHAPTERS.map((text, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.08 }}
            className={`flex gap-6 md:gap-12 max-w-3xl ${i % 2 === 1 ? "md:ml-auto" : ""}`}
          >
            <span className="font-editorial italic text-gold/60 text-2xl md:text-4xl leading-none pt-1 shrink-0">
              {String(i + 1).padStart(2, "0")}
            </span>
            <p
              data-testid={`manifesto-chapter-${i + 1}`}
              className="text-bone/75 text-base md:text-lg leading-relaxed"
            >
              {text}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
